import { getAuth, signOut } from 'firebase/auth';
import { setCurrentOrg, setSelectedOrg } from './appActions';
import parseJwt from '../helpers/parseJwt';
import { apis } from '../api';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

// Acción para iniciar sesión
export const login = (userData) => ({
  type: LOGIN,
  payload: userData,
});
export const setLoginLoading = (loading) => ({
  type: 'SET_LOGIN_LOADING',
  payload: loading,
});

export const authChecked = () => {
  return { type: 'ASSOCIATES_AUTH_CHECKED' };
};

export const exchangeToken = async (dispatch, user, callback = null) => {
  const token = await user.getIdToken();

  try {
    const response = await apis.manager.post(`/api/auth/exchange`, { token });
    await dispatch(associateAuthenticated(response.data.jwt));

    dispatch(getAssociateSaleSetup(response.data.jwt));

    if (typeof callback === 'function') {
      callback();
    }
    return response;
  } catch (error) {
    // Revisar el Logout
    dispatch(logout());
    console.error(error);
  }
};

// Acción para cerrar sesión
export const logout = (callback = null) => {
  return (dispatch) => {
    const auth = getAuth();
    localStorage.removeItem('currentOrg');
    localStorage.removeItem('selectedOrg');
    signOut(auth).then(() => {
      dispatch({ type: 'ASSOCIATES_LOGOUT' });
      if (typeof callback === 'function') {
        callback();
      }
    });
  };
};

export const getUserInfo = (jwt) => {
  return apis.manager.get(`/api/User/info`, {
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  });
};

export const associateAuthenticated = (jwt) => {
  const userDetails = jwt ? parseJwt(jwt) : null;
  const userRoles = userDetails['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

  return {
    type: 'ASSOCIATES_AUTHENTICATED',
    jwt,
    userRoles,
  };
};

export const getAssociateSaleSetup = (jwt) => {
  // const currOrg = JSON.parse(localStorage.getItem('currentOrg'));

  return async (dispatch) => {
    try {
      const setup = await apis.admin.get(`/api/user`, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      });

      await dispatch({
        type: 'ASSOCIATES_SALES_SETUP',
        payload: setup.data,
      });

      if (!localStorage.getItem('selectedOrg')) {
        await dispatch(
          setCurrentOrg({
            name: setup.data.companyUser.name,
            id: setup.data.companyUser.id,
          }),
        );
      }

      if (!localStorage.getItem('selectedOrg')) {
        await dispatch(
          setSelectedOrg({
            name: setup.data.companyUser.name,
            id: setup.data.companyUser.id,
          }),
        );
      }
      await dispatch({
        type: 'ASSOCIATES_INFO',
        payload: setup.data,
      });

      await dispatch({
        type: 'FETCH_CURRENCIES',
        payload: setup.data.currencies,
      });
    } catch (error) {
      console.error(error);
    }
  };
};
